import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '98%',
    margin: '8px 0 12px 0'
  },
  sliderContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  text: { fontWeight: 600, color: theme.palette.grey[800] },
  slider: {
    color: theme.palette.primary.main,
    height: 5,
    marginTop: 8,
    width: '95%',
    '& .MuiSlider-thumb:nth-of-type(2)': {
      width: 14,
      height: 14,
      left: -56,
      backgroundColor: theme.palette.background.default,
      border: `4px solid ${theme.palette.primary.main}`
    },
    '& .MuiSlider-rail': {
      backgroundColor: theme.palette.grey[500]
    },
    '& .MuiSlider-valueLabel': {
      top: 15,
      transform: 'none !important',
      '& > span': {
        transform: 'none !important',
        borderRadius: '0px !important',
        backgroundColor: 'transparent',
        display: 'flex !important', // enforce inline layout
        alignItems: 'center',
        '& > span': {
          left: -100,
          transform: 'none !important',
          color: theme.palette.grey[700],
          fontSize: 12,
          whiteSpace: 'nowrap'
        }
      }
    }
  },
  priceShow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '8px'
  },
  inputRoot: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: '4px 8px',
    '&:hover': {
      borderColor: theme.palette.grey[400]
    },
    fontSize: 12
  },
  input: { padding: '8px' },
  adornment: {
    marginLeft: theme.spacing(1),
    '& p': { fontSize: 12, color: theme.palette.primary.main }
  },
  inputField: { width: '49%' }
}))
export default useStyles
